export const excludedUrl401 = [
  "/auth/v1/init",
  "/auth/v1/login/otp",
  "/auth/v1/refresh",
  "/super-app/v1/versions",
];

export const excludedToLogout = ["/social/v1/init"];
